module.exports = __webpack_public_path__ + "static/media/11-mobile.b29853f8.jpg";